import React from "react"
import { AppRouteProps } from "@harea/component"

const SubscriptionCancellationContainer = React.lazy(() => import("./container/SubscriptionCancellationContainer"))

export const SubscriptionCancellationRoutes: Array<AppRouteProps> = [
    {
        path: "subscription/cancellation",
        title: "Harea.Billing.Subscription.Cancellation.Title",
        element: <SubscriptionCancellationContainer />,
        roles: ["CANCEL_SUBSCRIPTION"],
    },
]
